import { Injectable, inject } from '@angular/core';
import { Education, EducationStore } from '@dges/modules/portfolio/domain';
import { Actions, ofType } from '@ngrx/effects';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as EducationActions from './education.actions';
import * as EducationSelectors from './education.selectors';

@Injectable()
export class EducationFacade implements EducationStore {
  private store = inject(Store);
  private actions$ = inject(Actions);

  loaded$ = this.store.pipe(select(EducationSelectors.getEducationLoaded));
  allItems$ = this.store.pipe(select(EducationSelectors.getAllEducation));
  selectedItem$ = this.store.pipe(select(EducationSelectors.getSelected));

  load(): Observable<Education[]> {
    this.store.dispatch(EducationActions.loadEducation());
    return this.allItems$;
  }

  addItem(education: Education) {
    this.store.dispatch(EducationActions.addEducation({ education }));
  }

  editItem(education: Education) {
    this.store.dispatch(EducationActions.editEducation({ education }));
  }

  deleteItem(education: Education) {
    this.store.dispatch(EducationActions.deleteEducation({ education }));
  }

  editOrAddSuccess(): Observable<Actions> {
    return this.actions$.pipe(
      ofType(
        EducationActions.addEducationSuccess,
        EducationActions.editEducationSuccess,
      ),
    );
  }
}
